var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returnTopStyle",on:{"click":_vm.toTop}},[_c('img',{attrs:{"src":require("../assets/icon5.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }